import React, { Fragment } from 'react';
import { Image, Text, Line } from 'react-konva';
import { Layer, Stage, Rect } from 'react-konva';

// import assets from '../../containers/tree/assets';

import { isMobilePhone, truncateFullNameLineArrBasedOnFontSize, shadeColor } from '../../library/calc';
import {
  lineCap,
  relatedColor,
  picDim,
  fullNameFontSize,
  fontFamily,
  fullNameFontStyle,
  fullNameLineHeight,
  fullNameFontColor,
  nodeWidth,
  nodeHeight,
  maleDefaultColor,
  stageBackgroundDefaultColor,
} from '../../library/constants';
import Base from './base';
import './base.css';

export class NodeProfile extends Base {

  getFullName({ nodeNum, nodeX, gender }){

    const scaledDistanceFromNodeX_2_nameEdge = ((picDim * this.multiple)) + ( this.margin * 2 );

    let nameX = this.nodeX + ( scaledDistanceFromNodeX_2_nameEdge  );

    let maleName = 'Male';
    if( typeof(window.trl) !== 'undefined' ) maleName = window.trl(maleName);
    const male =
      truncateFullNameLineArrBasedOnFontSize( {
        fontSizeChoice: 'default',
        fullnameArrBasedOnFontSize: [maleName]
    })

    const fullnameTextArrayObj = {
      male
    }

    let row = 0;

    return fullnameTextArrayObj['male'].map((fullnameText, idx ) => {

      row++;

      return (

        <Text
          text={`${fullnameText}`}
          x={nameX}
          y={this.nameY + (this.scaleRowLineHeight * row)}
          width='auto'
          height={5 * this.multiple}
          fontSize={fullNameFontSize * this.multiple}
          fontFamily={fontFamily}
          fontStyle={fullNameFontStyle}
          lineHeight={fullNameLineHeight}
          fill={fullNameFontColor}
        />
      )
    });

  }

  getRectIcon({
    left,
    top,
    width,
    height,
    fill,
    cornerRadius,
    }) {

    return <Rect
      x={left}
      y={top}
      width={width}
      height={height}
      fill={fill}
      cornerRadius={cornerRadius}
    />;
  }

  getText_for_Icon({
    textLeft,
    textTop,
    text,
    fontSize
    }) {

    if(typeof(text) === 'undefined' ) text = '0';

    return <Text
          text={text}
          x={textLeft}
          y={textTop}
          width='auto'
          height={5 * this.multiple}
          fontSize={fontSize}
          fontFamily={fontFamily}
          fontStyle={fullNameFontStyle}
          fill={'#FFFFFF'}
        />
    ;
  }

  getImgIcon({
        src,
        left,
        top,
        width,
        height,
        strokeWidth,
        stroke,
        opacity
      }){

  return  <Image
            image={src}
            width={width}
            height={height}
            x={left}
            y={top}
            strokeWidth={strokeWidth}
            stroke={stroke}
            opacity={typeof(opacity) !== 'undefined' ? opacity: 1}
          />;
  }

  getUnionLine({
    x1,
    y1,
    x2,
    y2,
    strokeWidth,
    dash,
    stroke
    }) {

    const coords = [x1, y1, x2, y2];

    return (
      <Line
        points = {coords}
        stroke = {`${ typeof(stroke) !== 'undefined' ? stroke: relatedColor}`}
        strokeWidth = {strokeWidth}
        lineCap = {lineCap}
        perfectDrawEnabled={false}
        listening={false}
        dash={dash}
      />
    );
  }

  getStageNodeProfile(){

    this.buildIconHash();

    const scaledNodeW = nodeWidth * this.multiple;
    const scaledNodeH = nodeHeight * this.multiple;

    let width = isMobilePhone() ? window.innerWidth: 476;
    // width = width + 'px';

    return (

      <Fragment>

          <div
            id='nodeProfileLegendStageWrapper'
            style={{
              position: 'relative',
              left: '0px',
              top: '0px',
              width: `100%`,
              height: `100%`,
              backgroundColor: stageBackgroundDefaultColor,
              boxSizing: 'border-box',
              opacity: 1,
          }}>
            <Stage
              className="customNodeStage"
              ref={this.nodeProfileLegendStage}
              width={ width }
              height={240}
            >
              <Layer>


                  {

                    this.props.legendKey === 'merge'

                          ?

                          <Fragment>

                            {
                              this.getRectIcon({
                                left: this.nodeX + 4,
                                top: this.nodeY + 4,
                                width: scaledNodeW,
                                height: scaledNodeH,
                                fill: "#808080",
                              })
                            }

                          </Fragment>

                      :

                    null


                    }


                  {

                    typeof(this.props.addnodetab) !== 'undefined'

                          ?

                          <Fragment>

                            {
                              this.getImgIcon(this.iconHash[this.props.addnodetab])
                            }

                          </Fragment>

                      :

                    null


                    }





                <Rect
                  key={`maleNode`}
                  x={this.nodeX}
                  y={this.nodeY}
                  width={scaledNodeW}
                  height={scaledNodeH}

                  fillLinearGradientStartPoint={{  "x": 95,  "y": -90 }}

                  fillLinearGradientEndPoint={ { "x": 95, "y": 90 }}

                  fillLinearGradientColorStops = {[  0,  'white',  1,  maleDefaultColor ]}

                  stroke={`${shadeColor(maleDefaultColor, -20)}`}

                  strokeWidth={this.strokeWidth}

                />

                {/* Node */}

                  {
                    this.getFullName({nodeNum: 1, nodeX: this.nodeX, gender: 'male'})
                  }

                  {
                    this.getImgIcon(this.iconHash.porfilePic)
                  }

                  {
                    this.getImgIcon(this.iconHash.edit)
                  }

                  {
                    this.getImgIcon(this.iconHash.tree)
                  }


                {/* Dead */}

                  {
                    this.props.legendKey === 'dead' ? this.getImgIcon(this.iconHash.deadBanner): null
                  }


                {/* presumedDeceased */}

                  {
                    this.props.legendKey === 'presumedDeceased' ? this.getImgIcon(this.iconHash.presumedDeceased): null
                  }



                {/* Cycle */}

                    {

                      this.props.legendKey === 'cycle'

                            ?

                            <Fragment>

                              {
                                this.getRectIcon(this.iconHash.cycle)
                              }

                              {
                                this.getText_for_Icon(this.iconHash.cycle)
                              }

                            </Fragment>

                        :

                      null


                    }






                {/* Magnify */}

                    {

                      this.props.legendKey === 'match'

                            ?

                            <Fragment>

                              {
                                this.getImgIcon(this.iconHash.matches_magnify_svg)
                              }


                              {
                                this.getRectIcon(this.iconHash.matches_magnify_circle)
                              }

                              {
                                this.getText_for_Icon(this.iconHash.matches_magnify_circle)
                              }

                            </Fragment>

                        :

                      null


                    }


                {/* Merge */}

                    {

                      this.props.legendKey === 'merge'

                            ?

                            <Fragment>


                              {
                                this.getRectIcon(this.iconHash.merge)
                              }


                              {
                                this.getText_for_Icon(this.iconHash.merge)
                              }

                            </Fragment>

                        :

                      null


                    }



                {/* Inconsistency */}

                    {

                      this.props.legendKey === 'inconsistency'

                            ?

                            <Fragment>

                              {
                                this.getRectIcon(this.iconHash.inconsistency)
                              }


                              {
                                this.getText_for_Icon(this.iconHash.inconsistency)
                              }

                            </Fragment>

                        :

                      null


                    }




                {/* DNA */}

                    {

                      this.props.legendKey === 'dna'

                            ?

                            <Fragment>

                            {
                              this.getRectIcon(this.iconHash.dnaBlackBg)
                            }

                            {
                              this.getImgIcon(this.iconHash.dna)
                            }

                            </Fragment>

                        :

                      null


                    }




                {/* OtherFamily */}


                    {

                      this.props.legendKey === 'otherFamily'

                            ?

                            <Fragment>

                                {
                                  this.getRectIcon(this.iconHash.otherFamilyRect)
                                }

                                {
                                  this.getText_for_Icon(this.iconHash.otherFamilyRect)
                                }

                            </Fragment>

                        :

                      null


                    }


                {/* Prune */}


                    {

                      this.props.legendKey === 'prune'

                            ?

                            <Fragment>

                              {
                                this.props.legendKey === 'prune' ? this.getImgIcon(this.iconHash.prune): null
                              }

                              {
                                this.getText_for_Icon(this.iconHash.prune)
                              }

                            </Fragment>

                        :

                      null


                    }



                {/* GEDCOM */}

                  {
                    this.props.legendKey === 'gedcom' ? this.getImgIcon(this.iconHash.gedcom): null
                  }


                {/* Conflict */}


                  {
                   this.props.legendKey === 'conflict' ? this.getImgIcon(this.iconHash.conflict): null
                  }

                {/* lineGray */}


                  {
                   this.props.legendKey === 'lineGray' ? this.getUnionLine(this.iconHash.lineGrayUp): null
                  }


                  {
                   this.props.legendKey === 'lineGray' ? this.getUnionLine(this.iconHash.lineGraySide): null
                  }

                {/* lineBlack */}


                  {
                   this.props.legendKey === 'lineBlack' ? this.getUnionLine(this.iconHash.lineBlackUp): null
                  }


                  {
                   this.props.legendKey === 'lineBlack' ? this.getUnionLine(this.iconHash.lineBlackSide): null
                  }


                {/* lineDashed */}


                  {
                   this.props.legendKey === 'lineDashed' ? this.getUnionLine(this.iconHash.lineDashed): null
                  }

                {/* lineColors */}


                  {
                   this.props.legendKey === 'lineColors' ? this.getUnionLine(this.iconHash.lineColor1): null
                  }
                  {
                   this.props.legendKey === 'lineColors' ? this.getUnionLine(this.iconHash.lineColor2): null
                  }
                  {
                   this.props.legendKey === 'lineColors' ? this.getUnionLine(this.iconHash.lineColor3): null
                  }

              </Layer>
            </Stage>
          </div>


      </Fragment>
    );
  }

  render() {

    return this.getStageNodeProfile();


  }
}


